import React, { useState, useEffect } from 'react';
import './History.css';  // Assuming you add the CSS in this file

const History = ({ userDetails }) => {
  const [historyHtml, setHistoryHtml] = useState('');

  useEffect(() => {
    if (userDetails && userDetails.history) {
      // Process the history to create HTML content
      const historyEntries = userDetails.history.split('\n');
      
      const historyTable = historyEntries.map((entry, index) => (
        <tr key={index}>
          <td>{entry}</td>
        </tr>
      ));

      // Combine history rows into an HTML table
      const tableHtml = (
        <table className="history-table">
          <thead>
            <tr>
              <th>History Entry</th>
            </tr>
          </thead>
          <tbody>
            {historyTable}
          </tbody>
        </table>
      );

      setHistoryHtml(tableHtml);
    }
  }, [userDetails]);  // This will run when userDetails change

  return (
    <div className="history-container">
      <h2>Activity History</h2>
      
     
      {/* Display the history table */}
      <div className="history-table-container">
        {historyHtml || <p>No history available.</p>}
      </div>
    </div>
  );
};

export default History;
